module.exports = __webpack_public_path__ + "static/img/29.87be168.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/Brochure/29.jpg
// module id = SPP6
// module chunks = 1